import React from 'react';
import { motion } from 'framer-motion';
import { TOKENS } from '../tokens';
import { ChapterTag } from './Details';

const PROXIMITY = [
  { name: 'Jhandewalan Metro Station',  time: '2 min' },
  { name: 'Karol Bagh Market',          time: '5 min' },
  { name: 'Connaught Place',             time: '10 min' },
  { name: 'New Delhi Railway Station',  time: '12 min' },
  { name: 'IGI Airport',                time: '35 min' },
];

function ProxItem({ item, delay }) {
  const [hovered, setHovered] = React.useState(false);
  return (
    <motion.div
      initial={{ opacity: 0, x: -20 }}
      whileInView={{ opacity: 1, x: 0 }}
      viewport={{ once: true, amount: 0.3 }}
      transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1], delay }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        display: 'flex', alignItems: 'center', gap: 18,
        padding: '17px 0',
        paddingLeft: hovered ? 6 : 0,
        borderBottom: '1px solid rgba(255,255,255,0.07)',
        transition: 'padding-left 0.28s ease',
        cursor: 'default',
      }}
    >
      <div style={{
        width: 6, height: 6, borderRadius: '50%',
        background: TOKENS.GOLD, flexShrink: 0,
        boxShadow: `0 0 8px rgba(200,169,106,0.5)`,
      }} />
      <span style={{ flex: 1, fontSize: '0.84rem', fontWeight: 400, color: 'rgba(255,255,255,0.8)' }}>
        {item.name}
      </span>
      <span style={{
        fontFamily: "'Cormorant Garamond', serif",
        fontSize: '1.1rem', fontWeight: 300, color: TOKENS.GOLD,
      }}>
        {item.time}
      </span>
    </motion.div>
  );
}

export default function Location() {
  return (
    <section id="the-location" style={{ background: '#050A1A', padding: 'clamp(80px,10vw,140px) clamp(20px,4vw,48px)', overflow: 'hidden' }}>
      <div style={{ maxWidth: 1100, margin: '0 auto' }}>
        <ChapterTag text="Chapter 03 · Where It Sits" />

        <div style={{
          display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 80,
          marginTop: 60, alignItems: 'center',
        }} className="loc-grid">
          {/* Text side */}
          <motion.div
            initial={{ opacity: 0, x: -44 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
          >
            <h2 style={{
              fontFamily: "'Cormorant Garamond', serif",
              fontSize: 'clamp(2rem, 4vw, 3.5rem)',
              fontWeight: 300, lineHeight: 1.15,
              color: '#fff', marginBottom: 22,
            }}>
              Delhi doesn't<br />get more<br />
              <em style={{ fontStyle: 'italic', color: TOKENS.GOLD }}>central than this.</em>
            </h2>
            <p style={{ fontSize: '0.88rem', fontWeight: 300, lineHeight: 1.9, color: TOKENS.MUTED, marginBottom: 48 }}>
              Jhandewalan is not peripheral Delhi. It is the axis — the point where commerce, transit, and infrastructure converge. The kind of address that justifies a premium and then some.
            </p>

            <div>
              {PROXIMITY.map((item, i) => (
                <ProxItem key={item.name} item={item} delay={i * 0.08} />
              ))}
            </div>
          </motion.div>

          {/* Map side */}
          <motion.div
            initial={{ opacity: 0, x: 44 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1], delay: 0.1 }}
            style={{
              borderRadius: 20, overflow: 'hidden',
              height: 460, border: '1px solid rgba(255,255,255,0.07)',
              position: 'relative',
            }}
          >
            <iframe
              src={TOKENS.MAP_SRC}
              style={{ width: '100%', height: '100%', border: 'none', filter: 'grayscale(1) brightness(0.6) contrast(0.85) sepia(0.15) hue-rotate(180deg)' }}
              allowFullScreen loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Jhandewalan Map"
            />
            <div style={{
              position: 'absolute', inset: 0,
              borderRadius: 20,
              boxShadow: 'inset 0 0 60px rgba(0,0,0,0.45)',
              pointerEvents: 'none',
            }} />
          </motion.div>
        </div>
      </div>

      <style>{`
        @media (max-width: 768px) {
          .loc-grid { grid-template-columns: 1fr !important; gap: 40px !important; }
        }
      `}</style>
    </section>
  );
}
